"use client";

import { motion } from "framer-motion";
import Link from "next/link";
import { useLang } from "@/contexts/language-context";
import { Crown, Package, ArrowUpRight } from "lucide-react";

const PAIRS = [
  {
    slug: "vip-table-map",
    icon: Crown,
    label: { en: "VIP Table Map", es: "VIP Table Map" },
    desc: {
      en: "Bottle service from a table fires straight to the bar's tab. Same screen, same truth.",
      es: "El bottle service de la mesa cae directo en la tab de la barra. Misma pantalla, misma verdad.",
    },
  },
  {
    slug: "inventory-cogs",
    icon: Package,
    label: { en: "Inventory & COGS", es: "Inventario & COGS" },
    desc: {
      en: "Every recipe pour decrements stock. Variance reports tell you who's heavy-pouring.",
      es: "Cada pour por receta resta del stock. El reporte de varianza te dice quién está pour-eando pesado.",
    },
  },
];

export default function LiveBarTabsPairs() {
  const { t } = useLang();

  return (
    <section className="relative py-24 px-6 bg-[#0F0B1F] text-white overflow-hidden">
      <div className="relative max-w-[1080px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="mb-10"
        >
          <div className="text-[11px] font-black tracking-widest uppercase text-white/45 mb-3">
            {t("Pairs well with", "Combina bien con")}
          </div>
          <h2 className="text-2xl md:text-[36px] font-black tracking-tight">
            {t("The bar. The floor. ", "La barra. El floor. ")}
            <span className="text-white/40">{t("The stock. Connected.", "El stock. Conectados.")}</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {PAIRS.map((p, i) => {
            const Icon = p.icon;
            return (
              <motion.div
                key={p.slug}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.6, delay: 0.1 * i }}
              >
                <Link
                  href={`/features/${p.slug}`}
                  className="group block bg-white/[0.04] backdrop-blur-xl border border-white/10 rounded-[24px] p-7 hover:bg-white/[0.06] hover:border-white/20 hover:-translate-y-1 transition-all"
                >
                  <div className="flex items-start justify-between mb-5">
                    <div
                      className="w-12 h-12 rounded-[14px] flex items-center justify-center group-hover:scale-110 transition-transform"
                      style={{ backgroundColor: "rgba(124, 58, 237, 0.20)" }}
                    >
                      <Icon className="w-5 h-5" style={{ color: "#C4B5FD" }} />
                    </div>
                    <ArrowUpRight className="w-5 h-5 text-white/30 group-hover:text-white group-hover:rotate-12 transition-all" />
                  </div>
                  <div className="text-[18px] font-black text-white mb-2">
                    {t(p.label.en, p.label.es)}
                  </div>
                  <div className="text-[14px] font-medium text-white/55 leading-relaxed">
                    {t(p.desc.en, p.desc.es)}
                  </div>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
